import React, { ReactElement } from 'react'
import { Box } from '@mui/material'

interface layoutProps {
  children: ReactElement<any, any>
}

const Layout: React.FC<layoutProps> = ({ children }) => {
  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        overflowY: 'auto',
        overflowX: 'hidden',
        pb: { xs: 12, sm: 6 }, // space above fixed footer
      }}
    >
      {children}
    </Box>
  )
}

export default Layout
